import { weeklyWorkReportColors, workReportLineStatus } from '../../../../../utils/dataStatus';

/**
 * @typedef  IsVisibleEdit
 * @property {import('../../../reducer/optimisticUIReducer').OptimisticUIState} changedActions
 * @property {boolean} isInspector
 * @property {boolean} rectificaCantidad
 */

/** @param {IsVisibleEdit} */
export const isVisibleEdit = ({ changedActions, isInspector, rectificaCantidad }) => {
  // Es aprobador y puede editar cantidad.
  if (!isInspector && rectificaCantidad) return true;

  // Es aprobador y fijó o devolvió la cantidad
  if (
    !isInspector &&
    (changedActions.statusColors === weeklyWorkReportColors.approver.fixed ||
      changedActions.statusColors === weeklyWorkReportColors.approver.returned)
  ) {
    return true;
  }

  // Es inspector, puede rectificar y no realizó acciones.
  if (isInspector && rectificaCantidad && !changedActions.inspectionColor) return true;

  // Es inspector y realizó acciones que dejo la parte inferior
  // de la celda con estado `inspectorMustAct` o `errorSE`
  if (
    isInspector &&
    (changedActions.inspectionColor === weeklyWorkReportColors.inspector.inspectorMustAct ||
      changedActions.inspectionColor === weeklyWorkReportColors.inspector.errorSE)
  ) {
    return true;
  }

  return false;
};

/**
 * @typedef  IsVisibleReview
 * @property {import('../../../reducer/optimisticUIReducer').OptimisticUIState} changedActions
 * @property {number} estadoEnum
 * @property {boolean} isInspector
 * @property {boolean} rectificaCantidad
 * @property {boolean} revisionExperta
 */

/** @param {IsVisibleReview} */
export const isVisibleReview = ({
  changedActions,
  estadoEnum,
  isInspector,
  rectificaCantidad,
  revisionExperta
}) => {
  // Es aprobador y el parte se encuentra en estado enviado
  // (tiene cantidades cargadas y puede aprobarlo) y todavía
  // no marco la revisión experta.
  if (
    !isInspector &&
    estadoEnum === workReportLineStatus.enviar &&
    changedActions.inspectionColor !== weeklyWorkReportColors.inspector.revision &&
    !revisionExperta
  ) {
    return true;
  }

  // Es aprobador, puede rectificar pero ya marcó revisión experta
  if (!isInspector && rectificaCantidad && revisionExperta) return false;

  // Es aprobador y puede rectificar cantidad pero todavía no
  // realizó ninguna acción que afecte la parte inferior de
  // la celda (fijar cantidad)
  if (!isInspector && rectificaCantidad && !changedActions.inspectionColor) return true;

  // Es inspector, puede rectificar, tiene marcada la revisión
  // experta y todavia no tomo acciones que afecte la parte
  // inferior de la celda (rectificar, autorizar, rechazar o
  // desmarcar  revisión)
  if (isInspector && rectificaCantidad && revisionExperta && !changedActions.inspectionColor) {
    return true;
  }

  return false;
};
